import media from 'style-utils/media-queries';
import styled from 'styled-components';

export const BettingWarningBannerContainer = styled.div<{
  isSticky?: boolean;
  isApp?: boolean;
}>`
  display: flex;
  align-items: center;

  padding: 8px;
  height: var(--betting-banner-height);
  width: 100%;

  position: sticky;
  top: 0 !important;
  z-index: 101;

  ${media.desktop`
  top: ${({ isApp }) => (isApp ? '0' : '50px')};
    padding: 16px 8px;
    height: var(--betting-banner-height-md);
  `}
`;

export const FrBannerContainer = styled(BettingWarningBannerContainer)`
  gap: 10px;
  border: 1px solid #000;
  background: #ffe600;
  justify-content: space-between;
`;

export const EsBannerContainer = styled(BettingWarningBannerContainer)`
  border: 2px solid #ffffff;
  box-shadow: inset 0 0 0 2px #000;
  background: #ffffff;
  justify-content: center;
  text-align: center;
`;
